const testimonialsData = [
  {
    name: "Samson Adebayo",
    title: "Ceo & Founder Aurg",
    image: "./assets/img/testimonials/testi-1.png",
    feedback:
      "Partnering with Zedflux Technologies was one of the best decisions I've made for our company.",
    stars: 5,
  },
  {
    name: "Tosin Wilsson",
    title: "Designer at TechCorp",
    image: "./assets/img/testimonials/testi-2.png",
    feedback:
      "Zedflux's team is highly professional and delivers exceptional results.",
    stars: 4,
  },
  {
    name: "Jennifer Doe",
    title: "Store Owner",
    image: "./assets/img/testimonials/testi-3.png",
    feedback:
      "The team at Zedflux is incredibly talented and dedicated. They exceeded my expectations.",
    stars: 5,
  },
  {
    name: "Micheal Smith",
    title: "Freelancer",
    image: "./assets/img/testimonials/testi-4.png",
    feedback:
      "Zedflux provided excellent service and delivered a high-quality product on time.",
    stars: 4,
  },
  {
    name: "John Larson",
    title: "Entrepreneur",
    image: "./assets/img/testimonials/testi-5.png",
    feedback:
      "I highly recommend Zedflux Technologies for their professionalism and expertise.",
    stars: 5,
  },
];

export default testimonialsData;
